import { z } from 'zod/v4';

import { DEPLOYMENT_STATES } from 'types/deployment';
import { GATEWAY_STATES } from 'types/gateway';

const DeploymentLogSchema = z.object({
  timestamp: z.string(),
  msg: z.string(),
});

export const MqttDeploymentLogSchema = z.object({
  logs: z.array(DeploymentLogSchema),
});

export type MqttDeploymentLog = z.infer<typeof MqttDeploymentLogSchema>;
export type DeploymentLog = z.infer<typeof DeploymentLogSchema>;

export const MqttGatewayStateSchema = z.object({
  status: z.enum(GATEWAY_STATES),
  version: z.string(),
});

export const MqttDeploymentStateSchema = z.object({
  state: z.enum(DEPLOYMENT_STATES),
  state_details: z.string().nullable(),
});
